export const APPLYAPPROVALMANAGEMENT_FILE = 'APPLYAPPROVALMANAGEMENT_FILE';
// 更新
export const APPLYAPPROVALMANAGEMENT_UPDATE = 'APPLYAPPROVALMANAGEMENT_UPDATE';

export const CHANGEQUERIESMANAGEMENT_FILE = 'CHANGEQUERIESMANAGEMENT_FILE';
